import request from '@/common/request/request'
const prefix = '/res/resPress/'
// 分页获取测试列表
export const getCurrentPressInfoApi = () => {
  return request.request({
    url: prefix + 'openapi/getCurrentPressInfo',
    method: 'get'
  })
}
